import React from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import CreateIcon from '@material-ui/icons/Create';
import UpdateIcon from '@material-ui/icons/Update';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import EmailIcon from '@material-ui/icons/Email';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import RestoreIcon from '@material-ui/icons/Restore';
import PeopleIcon from '@material-ui/icons/People';
import StorageIcon from '@material-ui/icons/Storage';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import "../Preventive Maintenance/PreventiveMaintenance.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';

const Settings = () => {
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
    ];

    const handler = (route) => {
        navigate(route)
    }


    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Settings
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Settings" />
                </Box>
                <Box mb={2}>
                    <Typography variant="body1" style={{ fontSize: 'clamp(1rem, 1.5vw, 1.5rem)', fontWeight: 400 }}>
                        Select an option
                    </Typography>
                </Box>

                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5} className='PM' onClick={() => { handler("/user-management") }}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <GroupAddIcon />
                                    <p className='text'>
                                        User Management
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={5} className='PM'  onClick={() => handler("/data-management")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <CloudUploadIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Data Management
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={5} className='PM' onClick={() => { handler("/mail-management") }}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <EmailIcon />
                                    <p className='text'>
                                        Mail and Alert Management
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={5} className='PM' onClick={() => { handler("/setting/redis") }}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <RestoreIcon />
                                    <p className='text'>
                                        Redis
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={5} className='PM' onClick={() => { handler("/bulk-pv-plan-create") }}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <EmailIcon />
                                    <p className='text'>
                                        Manage PV Plans for Supplier
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                </Box>

                {/* <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={10} className='PM' onClick={() => { handler("/user-management") }}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <GroupAddIcon />
                                        <p className='text'>
                                            User Management
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item className='PM' xs={12} sm={10} onClick={() => handler("/pm/log-overview")}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <CloudUploadIcon className='MuiIcon-fontSizeLarge' />
                                        <p className='text'>
                                            Data Management
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                       
                    </Grid>
                </Grid> */}
            </Container>
        </Layout >
    );
};

export default Settings;
